// extracted by mini-css-extract-plugin
export default {"container":"dragon_container__2BxsL","loading":"dragon_loading__01Oqw","outerBox":"dragon_outerBox__KgJuF","innerBox":"dragon_innerBox__y7QNp"};